var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ModalWrapper', {
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "after-enter": function afterEnter($event) {
        return _vm.$emit('after-enter');
      },
      "enter": function enter($event) {
        _vm.isVisibleContent = true;
      },
      "before-leave": function beforeLeave($event) {
        _vm.isVisibleContent = false;
      },
      "after-leave": function afterLeave($event) {
        return _vm.$emit('after-leave');
      },
      "close": function close($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    class: [_vm.$style.IframeModal, _vm.classList]
  }, [_c(_vm.tag, {
    tag: "component",
    class: _vm.$style.inner,
    attrs: {
      "src": _vm.url,
      "loading": "lazy"
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };